import { render, staticRenderFns } from "./AdminListados.vue?vue&type=template&id=8322aaba"
import script from "./AdminListados.vue?vue&type=script&lang=js"
export * from "./AdminListados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports